import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { JobOpeningsPage } from '@_pages/engineering/job-openings/components';
import getJobData from '@_pages/engineering/job-openings/jobData';

export async function getServerSideProps({ query, locale }) {
  const { data, marketingJobs: marketingJobs } = await getJobData();

  if (marketingJobs.allJobs.length === 0) {
    return { redirect: { destination: '/engineers/job-openings' } };
  }

  return {
    props: {
      allJobsData: data ?? null,
      marketingJobs,
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default JobOpeningsPage;
